import type { CardConfiguration, GooglePayConfiguration } from '@adyen/adyen-web';
import { ADYEN_CARD_STYLES } from './styles';

export const ADYEN_APPLE_PAY_TYPE = 'applepay';

export const ADYEN_GOOGLE_PAY_CONFIG: GooglePayConfiguration = {
  callbackIntents: [],
  showPayButton: true,
  isExpress: true,
  buttonSizeMode: 'fill',
  buttonRadius: 5,
  emailRequired: true,
};

export const ADYEN_GOOGLE_PAY_TYPE = 'googlepay';

export const ADYEN_CARD_BRANDS = ['visa', 'mc', 'amex', 'discover', 'maestro', 'diners', 'jcb', 'cup'] as const;

export const ADYEN_PAYMENT_METHOD_TYPE = 'scheme';
export const ADYEN_PAYMENT_METHOD_NAME = 'Cards';

export const ADYEN_CARD_FIELD = 'encryptedCardNumber';
export const ADYEN_DATE_FIELD = 'encryptedExpiryDate';
export const ADYEN_CVC_FIELD = 'encryptedSecurityCode';

export const ADYEN_THREEDS_CONTAINER_ID = 'threeds-container';

export const ADYEN_3DS_CONTAINER_ID = 'adyen-card-3ds-form';

export const ADYEN_CARD_CONFIG: CardConfiguration = {
  hasHolderName: true,
  holderNameRequired: true,
  billingAddressRequired: false,
  exposeExpiryDate: true,
  showPayButton: false,
  enableStoreDetails: false,
  showInstallmentAmounts: false,
  showStoreDetailsCheckbox: false,
  configuration: {
    socialSecurityNumberMode: 'hide',
  },
  showBrandIcon: false,
  styles: ADYEN_CARD_STYLES,
  hideCVC: false,
  showContextualElement: false,
  placeholders: {
    cardNumber: 'Card Number',
    expiryDate: 'MM/YY',
    securityCodeThreeDigits: 'CVC',
    securityCodeFourDigits: 'CVC',
    holderName: 'Cardholder Name',
  },
};
